const accordionButtons = document.querySelectorAll('.recieved-reviews-item .accordion-button, .given-reviews-item .accordion-button');

accordionButtons.forEach(button => {
  button.addEventListener('click', function () {
    const wrapper = this.closest('.recieved-reviews-item, .given-reviews-item');
    const isCollapsed = this.classList.contains('collapsed');

    document.querySelectorAll('.recieved-reviews-item, .given-reviews-item').forEach(item => {
      if (item !== wrapper) {
        item.classList.remove('open');
      }
    });

    if (!isCollapsed) {
      wrapper.classList.add('open');
    } else {
      wrapper.classList.remove('open');
    }
  });
});
